module.exports = __webpack_public_path__ + "img/1567837676.9503e4e7.jpg";